import React from 'react';
import ReactPlayer from 'react-player';
export var VideoPlayer = function (_a) {
    var videoUrl = _a.videoUrl;
    return (React.createElement(React.Fragment, null,
        React.createElement(ReactPlayer, { controls: true, loop: true, url: videoUrl, width: "100%", height: "20rem", style: { marginTop: '36px' } })));
};
